import mens from "../components/img/MensFormat.jpg";
import womens from "../components/img/WomensFormat.jpg";

function Home() {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				textAlign: "center",
			}}
		>
			<h2>Tournament Format for December Tournament</h2>
			<hr />
			<h2>Men's Format</h2>
			<img src={mens} style={{ width: "80vw" }} />
			<hr />
			<h2>Women's Format</h2>
			<img src={womens} style={{ width: "80vw" }} />
			<hr />
		</div>
	);
}
export default Home;
